<!-- Cliente (Filtrar) — pedidos-cadastro.component.html:649-748 -->
<ng-container *ngIf="(pedido == null && produtosAdicionados.length == 0 && clienteSelecionadoExterno == '') || duplicandoPedido">
  <form [formGroup]="formFiltroCliente" (ngSubmit)="filtroSubmetido.emit()">
    <div class="form-row">
      <div class="form-group col-sm-2">
        <label class="text-secondary"><b>Filtrar Cliente por:</b></label>
        <select class="form-control form-control-sm" name="filtrar_cliente_por" formControlName="filtro" (change)="filtroAlterado.emit($event.target.value)">
          <option *ngFor="let opcao of filtroClientes" [value]="opcao.valor" [selected]="opcao.valor == formFiltroCliente.controls['filtro'].value">{{ opcao.texto }}</option>
        </select>
      </div>
      <!-- Código -->
      <div class="form-group col-sm-2" *ngIf="formFiltroCliente.controls['filtro'].value == 0">
        <label class="text-secondary"><b>Código:</b></label>
        <input class="form-control form-control-sm" type="text" name="cliente_filtrar_codigo" [ngClass]="{ 'is-invalid': enviadoCliente && formFiltroCliente.controls['codigo'].errors?.required }" formControlName="codigo" />
        <div class="erro pt-1" *ngIf="enviadoCliente && formFiltroCliente.controls['codigo'].errors?.required">Código em branco!</div>
      </div>
      <!-- CNPJ/CPF -->
      <div class="form-group col-sm-2" *ngIf="formFiltroCliente.controls['filtro'].value == 1">
        <label class="text-secondary"><b>CNPJ/CPF:</b></label>
        <input class="form-control form-control-sm" type="text" name="cliente_filtrar_cnpj_cpf" [ngClass]="{ 'is-invalid': enviadoCliente && formFiltroCliente.controls['cnpj_cpf'].errors?.required }" formControlName="cnpj_cpf" />
        <div class="erro pt-1" *ngIf="enviadoCliente && formFiltroCliente.controls['cnpj_cpf'].errors?.required">CNPJ/CPF em branco!</div>
      </div>
      <!-- Nome Fantasia -->
      <div class="form-group col-sm-4" *ngIf="formFiltroCliente.controls['filtro'].value == 2">
        <label class="text-secondary"><b>Nome Fantasia:</b></label>
        <input class="form-control form-control-sm" type="text" name="cliente_filtrar_nome_fantasia" [ngClass]="{ 'is-invalid': enviadoCliente && formFiltroCliente.controls['nome_fantasia'].errors?.required }" formControlName="nome_fantasia" />
        <div class="erro pt-1" *ngIf="enviadoCliente && formFiltroCliente.controls['nome_fantasia'].errors?.required">Nome Fantasia em branco!</div>
      </div>
      <!-- Razão Social -->
      <div class="form-group col-sm-4" *ngIf="formFiltroCliente.controls['filtro'].value == 3">
        <label class="text-secondary"><b>Razão Social:</b></label>
        <input class="form-control form-control-sm" type="text" name="cliente_filtrar_razao_social" [ngClass]="{ 'is-invalid': enviadoCliente && formFiltroCliente.controls['razao_social'].errors?.required }" formControlName="razao_social" />
        <div class="erro pt-1" *ngIf="enviadoCliente && formFiltroCliente.controls['razao_social'].errors?.required">Razão Social em branco!</div>
      </div>
      <!-- Cidade -->
      <div class="form-group col-sm-4" *ngIf="formFiltroCliente.controls['filtro'].value == 4">
        <label class="text-secondary" for="cliente_filtrar_cidade"><b>Cidade:</b></label>
        <input id="cliente_filtrar_cidade" class="form-control form-control-sm" type="text" name="cliente_filtrar_cidade" [ngClass]="{ 'is-invalid': enviadoCliente && formFiltroCliente.controls['cidade'].invalid }" formControlName="cidade" />
        <div class="erro pt-1" *ngIf="enviadoCliente && formFiltroCliente.controls['cidade'].invalid">Informe a cidade!</div>
      </div>
      <div class="col-sm-6 pedido-filtro-acoes">
        <button class="btn btn-secondary btn_filtro" type="submit">Filtrar</button>
        <button class="btn btn-secondary btn_filtro" type="button" *ngIf="filtrandoCliente" (click)="filtroAlterado.emit(null)">Cancelar</button>
        <button class="btn btn-sm btn-outline-primary pedido-local-entrega-btn" type="button" *ngIf="clienteSelecionado != null" (click)="abrirLocaisEntrega.emit(modalLocaisEntrega)">
          <i class="fa fa-truck"></i> Locais de Entrega
        </button>
      </div>
    </div>
  </form>
  <hr class="mt-2 mb-2" />
  <div [@esvanecerDesvanecer]="'in'" *ngIf="filtrandoCliente">
    <div class="filtrar_cliente p-1">
      <div class="table-responsive">
        <cdk-virtual-scroll-viewport class="filtrar_cliente_tabela" [itemSize]="itemSizeEfetivo">
          <table class="table table-sm table-hover pedido-cliente-busca-tabela">
            <thead>
              <tr>
                <th class="text-center">Código</th>
                <th class="tabela_borda">Cliente</th>
                <th class="tabela_borda">Vendedor</th>
                <th class="tabela_borda text-center">CNPJ/CPF</th>
                <th class="tabela_borda">Endereço</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *cdkVirtualFor="let cliente of clientes; trackBy: trackByCodigo; templateCacheSize: 0;">
                <tr class="filtrar_cliente_acao" (click)="clienteEscolhido.emit({ codigo: cliente.codigo_no_erp_do_cliente, existente: false })">
                  <td class="text-center" data-label="Código">{{ cliente.codigo_no_erp_do_cliente }}</td>
                  <td class="tabela_borda" data-label="Cliente">{{ cliente.name }}</td>
                  <td class="tabela_borda" data-label="Vendedor">{{ cliente.fullname }}</td>
                  <td class="tabela_borda text-center" data-label="CNPJ/CPF">{{ cliente.client_document }}</td>
                  <td class="tabela_borda" data-label="Endereço">{{ cliente.endereco_completo }}</td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    <hr class="mt-2 mb-2" />
  </div>
</ng-container>
